const analysisSampling =
{
    additionalType : 'Type de prélèvement',
    mandatory      : 'Obligatoire'
};

export default analysisSampling ;